// import { Api } from 'yxt-biz-pc';
// const { kngApi } = Api;
import { kngApi } from 'yxt-biz-pc/packages/api';
// 选择学院的列表数据
export const getCollegeList = () => {
  return kngApi.get('/college/listasmanager');
};
